import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import Api from '@/services/api/ApiServiceFabrick';
import { DOWNLOAD_DATA_FORMATS, CSV_DATA_EXPORT_FORMATS } from '@/services/consts';
import StatusBadge from '@/components/DownloadDataHistoriesParts/StatusBadge.vue';
import getDownloadData from '@/types/responses/getDownloadData';
import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DataRow',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props;

function download() {
  const filepath = props.item.file_path;
  if (filepath) {
    Api().fileDownload(filepath);
  }
}
const accountName = computed(() => {
  return props.item.account.full_name ?? ''
});

const formatName = computed(() => {
  const format = props.item?.type;
  const allFormats = [...DOWNLOAD_DATA_FORMATS, ...CSV_DATA_EXPORT_FORMATS];
  return allFormats.find((v) => v.request_type == format)?.title;
});

const fileName = computed(() => {
  const path = props.item.file_path;
  return path?.replace(/^.*\//g, '');
});

const fileType = computed(() => {
  return 'csv'
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", null, _toDisplayString(__props.item.exit_at), 1),
    _createElementVNode("td", null, [
      _createVNode(StatusBadge, {
        status: __props.item.status,
        hasMessage: false
      }, null, 8, ["status"])
    ]),
    _createElementVNode("td", null, _toDisplayString(accountName.value), 1),
    _createElementVNode("td", null, _toDisplayString(formatName.value), 1),
    _createElementVNode("td", null, _toDisplayString(fileName.value), 1),
    _createElementVNode("td", null, _toDisplayString(fileType.value), 1),
    _createElementVNode("td", null, [
      (props.item.exit_at && props.item.status == 'success')
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (download()), ["prevent","stop"]))
          }, _toDisplayString(_unref(i18n).global.t('common.downloadBtn')), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})